module.exports = __webpack_public_path__ + "f05510bacdf4b785c4749ce2cdacfac7.png";